import React, { useContext, useEffect } from "react";
import { Box } from "@mui/material";
import MDTypography from "components/MDTypography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { AuthContext } from "context";
import Link from "@mui/material/Link";
import SidenavCollapse from "./SidenavCollapse";
import { NavLink } from "react-router-dom";
import Divider from "@mui/material/Divider";
import FactoryIcon from "@mui/icons-material/Factory";

function SubMenuQuality(props) {
	const authContext = useContext(AuthContext);
	const [isHovered, setIsHovered] = React.useState(false);
	const [submenuOpen, setSubmenuOpen] = React.useState(false);
	const [calcestruzzoOpen, setCalcestruzzoOpen] = React.useState(false);
	const [acciaioOpen, setAcciaioOpen] = React.useState(false);

	// Funzione per verificare se ci sono le autorizzazioni per le route
	const hasAnyAuth = (routeAuths) => {
		if (!routeAuths || routeAuths.length === 0) return true;
		return routeAuths.some((auth) => authContext.hasAuth(auth));
	};

	// Filtra le route basate sulle autorizzazioni per Calcestruzzo
	const filteredCalcestruzzoRoutes = props?.routes.filter((route) => {
		if (route.type === "Qualità > Calcestruzzo")
			return hasAnyAuth(route.auths);
	});

	// Filtra le route basate sulle autorizzazioni per Acciaio
	const filteredAcciaioRoutes = props?.routes.filter((route) => {
		if (route.type === "Qualità > Acciaio") return hasAnyAuth(route.auths);
	});

	// Filtra le route basate sulle autorizzazioni per Qualità generale
	const filteredGeneralQualityRoutes = props?.routes.filter((route) => {
		if (route.type === "Qualità") return hasAnyAuth(route.auths);
	});

	const renderRoutesType = (routes) => {
		return routes.map(
			({
				type,
				name,
				icon,
				title,
				noCollapse,
				key,
				href,
				route,
				showInSidebar,
			}) => {
				let returnValue;

				if (showInSidebar) {
					returnValue = href ? (
						<Link
							href={href}
							key={key}
							target="_blank"
							rel="noreferrer"
							sx={{ textDecoration: "none" }}
						>
							<SidenavCollapse
								name={name}
								icon={icon}
								active={
									key === props?.collapseName.split("/")[0]
								}
								noCollapse={noCollapse}
							/>
						</Link>
					) : (
						<NavLink key={key} to={route}>
							<SidenavCollapse
								name={name}
								icon={icon}
								active={
									key === props?.collapseName.split("/")[0]
								}
							/>
						</NavLink>
					);
				}
				return returnValue;
			}
		);
	};

	function handleMouseEnter() {
		setIsHovered(true);
	}

	function handleMouseLeave() {
		setIsHovered(false);
	}

	function handleSubmenuOpen() {
		setSubmenuOpen((prevState) => !prevState);
	}

	function handleCalcestruzzoOpen() {
		setCalcestruzzoOpen((prevState) => !prevState);
	}

	function handleAcciaioOpen() {
		setAcciaioOpen((prevState) => !prevState);
	}

	// Se non ci sono route per nessuna delle categorie, non mostrare il menu
	if (
		filteredCalcestruzzoRoutes.length === 0 &&
		filteredAcciaioRoutes.length === 0 &&
		filteredGeneralQualityRoutes.length === 0
	) {
		return null;
	}

	return (
		<>
			<Box>
				{/* Menu principale Qualità */}
				<Box
					display="flex"
					alignItems="center"
					justifyContent="center"
					style={{
						cursor: "pointer",
						transition: "all 0.3s ease-in-out",
					}}
					onMouseEnter={() => handleMouseEnter()}
					onMouseLeave={() => handleMouseLeave()}
					onClick={() => handleSubmenuOpen()}
				>
					<MDTypography
						color={"white"}
						variant="body2"
						fontWeight="medium"
						style={{
							fontSize: isHovered ? "1.1rem" : "1rem",
							transition: "all 0.2s ease-in",
						}}
					>
						Qualità
					</MDTypography>
					<KeyboardArrowDownIcon
						color={"white"}
						style={{ marginLeft: "5px" }}
						fontSize={"medium"}
					/>
				</Box>

				{submenuOpen && (
					<Box sx={{}}>
						{/* Routes generali di Qualità */}
						{filteredGeneralQualityRoutes.length > 0 && (
							<Box sx={{}}>
								{renderRoutesType(filteredGeneralQualityRoutes)}
							</Box>
						)}

						{/* Sottomenu Calcestruzzo */}
						{filteredCalcestruzzoRoutes.length > 0 && (
							<Box>
								<Box
									style={{
										cursor: "pointer",
										padding: "8px 0",
										paddingRight: "24px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
									onClick={() => handleCalcestruzzoOpen()}
								>
									<MDTypography
										color={"white"}
										variant="body2"
										fontWeight="regular"
										style={{ fontSize: "1rem" }}
									>
										Calcestruzzo
									</MDTypography>
									<KeyboardArrowDownIcon
										fontSize="small"
										style={{
											color: "white",
										}}
									/>
								</Box>
								{calcestruzzoOpen && (
									<Box sx={{ paddingLeft: "20px" }}>
										{renderRoutesType(
											filteredCalcestruzzoRoutes
										)}
									</Box>
								)}
							</Box>
						)}

						{/* Sottomenu Acciaio */}
						{filteredAcciaioRoutes.length > 0 && (
							<Box>
								<Box
									display="flex"
									alignItems="center"
									style={{
										cursor: "pointer",
										padding: "8px 0",
										paddingRight: "24px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
									onClick={() => handleAcciaioOpen()}
								>
									<MDTypography
										color={"white"}
										variant="body2"
										fontWeight="regular"
										style={{ fontSize: "1rem" }}
									>
										Acciaio
									</MDTypography>
									<KeyboardArrowDownIcon
										fontSize="small"
										style={{
											color: "white",
										}}
									/>
								</Box>
								{acciaioOpen && (
									<Box sx={{ paddingLeft: "20px" }}>
										{renderRoutesType(
											filteredAcciaioRoutes
										)}
									</Box>
								)}
							</Box>
						)}
					</Box>
				)}
			</Box>
			<Divider light={true}></Divider>
		</>
	);
}

export default SubMenuQuality;
